/**
 * Explore 一键成稿埋点：ckpt_type 转换（0917 起 A3 与内部码一致）。
 * 独立小文件，避免测试/调用方被 model/data 的展示选项副作用拖入。
 */

/**
 * Explore 埋点 ckpt_type 映射表。
 * 若产品再次要求 Explore 与画布分口径，在此登记；未知类型原样返回。
 */
export const EXPLORE_CKPT_TYPE_TRACKING_MAP: Record<string, string> = {};

/** 将内部 ckptType 转为 Explore 埋点 ckpt_type；未知则原样返回 */
export function mapExploreCkptTypeForTracking(ckptType?: string | null): string {
  if (!ckptType) return '';
  return EXPLORE_CKPT_TYPE_TRACKING_MAP[ckptType] ?? ckptType;
}
